import React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, device } from '../../../../constants';

interface IndustriesProgressProps {
  currentIndex: number;
  count: number;
  progressClick: (index: number) => void;
}

const IndustriesProgress = ({
  currentIndex,
  count,
  progressClick,
}: IndustriesProgressProps) => {
  return (
    <IndustriesProgressWrapper>
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <IndustriesProgressItemContainer
            key={i}
            onClick={() => progressClick(i)}
          >
            <IndustryProgressItem $isActive={i === currentIndex} />
          </IndustriesProgressItemContainer>
        ))}
    </IndustriesProgressWrapper>
  );
};

const IndustriesProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  @media screen and ${device.bsm} {
    order: 2;
    flex-direction: row;
  }
  @media screen and ${device.sm} {
    justify-content: space-between;
    width: 75%;
  }
`;
const IndustriesProgressItemContainer = styled.div`
  padding: 10px;
  @media screen and ${device.sm} {
    padding: 5px;
  }
`;
const IndustryProgressItem = styled.div<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? css`
          width: 40px;
          background: ${COLORS.PRODUCTS_ARROW};
        `
      : css`
          width: 20px;
          background: ${COLORS.BG_CIRCLE};
        `}
  height: 4px;
  @media screen and ${device.bsm} {
    ${({ $isActive }) =>
      $isActive
        ? css`
            height: 40px;
            background: ${COLORS.PRODUCTS_ARROW};
          `
        : css`
            height: 20px;
            background: ${COLORS.BG_CIRCLE};
          `}
    width: 4px;
  }
  @media screen and ${device.sm} {
    ${({ $isActive }) =>
      $isActive
        ? css`
            height: 25px;
            background: ${COLORS.PRODUCTS_ARROW};
          `
        : css`
            height: 15px;
            background: ${COLORS.BG_CIRCLE};
          `}
    width: 3px;
  }
`;

export default IndustriesProgress;
